import React from 'react';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { PermissionOutput } from '@app/models/users';

import { getGrantedScopes } from '../../../../services';

interface IProps {
  permissions?: PermissionOutput[];
}

/** Справочная таблица «что даёт роль» (только для чтения). Разделы с уровнем «Запрещено» не показываются. */
export const RolePermissionsPreview: React.FC<IProps> = ({ permissions }) => {
  const assignments = useTranslation(NSKeys.assignments);
  const spaceT = useTranslation(NSKeys.spaceSettings);
  const granted = getGrantedScopes(permissions);

  if (!granted.length) {
    return null;
  }

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', margin: '12px 0' }}>
      <thead>
        <tr style={{ background: '#fafafa', color: '#8c8c8c', fontSize: 11, letterSpacing: '0.04em' }}>
          <th style={{ textAlign: 'left', padding: '6px 8px', fontWeight: 600 }}>{assignments.t('preview.title')}</th>
          <th style={{ textAlign: 'right', padding: '6px 8px', fontWeight: 600 }}>{assignments.t('preview.level')}</th>
        </tr>
      </thead>
      <tbody>
        {granted.map((g) => (
          <tr key={g.scope}>
            <td style={{ padding: '6px 8px', borderTop: '1px solid #f5f5f5' }}>
              {spaceT.t(`role-scope.${g.scope}` as any)}
            </td>
            <td style={{ padding: '6px 8px', borderTop: '1px solid #f5f5f5', textAlign: 'right', color: '#389e0d' }}>
              {spaceT.t(`role-level.${g.level}` as any)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
